import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';
import { fonts, colors } from '../styles/theme';

const WrapperDiv = styled('div')`
  font-family: ${fonts.sans.family};
  border: 1px solid ${colors.red.primary};
  background-color: rgba(255, 0, 0, 0.2);
  padding: 15px;
  color: red;
`;

const ErrorDisplay = (props) => {
  const { children } = props;
  return (
    <WrapperDiv>
      <span>Component Error: </span>
      {children}
    </WrapperDiv>
  );
};

ErrorDisplay.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};

export default ErrorDisplay;
